import React, {FC, useEffect, useLayoutEffect, useRef, useState} from 'react';
import styles from './row-menu.module.scss'

export interface MenuItem {
    label: string;
    onClick: () => void;
    disabled?: boolean;
}

interface RowMenuProps {
    items: MenuItem[];
}

const RowMenu: FC<RowMenuProps> = ({ items }) => {
    const [isOpen, setIsOpen] = useState<boolean>(false);
    const [dropUp, setDropUp] = useState(false);
    const menuRef = useRef<HTMLDivElement>(null);
    const bodyRef = useRef<HTMLDivElement>(null);

    const toggleMenu = (event: React.MouseEvent<HTMLButtonElement>) => {
        event.stopPropagation();
        setIsOpen(!isOpen);
    }

    const handleClickOutside = (event: MouseEvent) => {
        if (menuRef.current && !menuRef.current.contains(event.target as Node)) {
            setIsOpen(false);
        }
    }

    useEffect(() => {
        document.addEventListener('mousedown', handleClickOutside);

        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        }
    }, [])

    useLayoutEffect(() => {
        if (isOpen && menuRef.current && bodyRef.current) {
            const wrapperRect = menuRef.current.getBoundingClientRect();
            const bodyHeight = bodyRef.current.getBoundingClientRect().height;
            const spaceBelow = window.innerHeight - wrapperRect.bottom;
            const enoughSpaceBelow = spaceBelow >= bodyHeight;

            setDropUp(!enoughSpaceBelow);
        }
    }, [isOpen]);

    return (
        <div className={styles.menu} ref={menuRef} >
            <button onClick={(event) => toggleMenu(event)} className={`${styles.dotBtn} ${isOpen ? styles.open : ''}`}>
                <span className={styles.dot}></span>
                <span className={styles.dot}></span>
                <span className={styles.dot}></span>
            </button>
            {isOpen && (
                <div
                    className={`${styles.body} ${dropUp ? styles.dropUp : ''}`}
                    ref={bodyRef}
                >
                    <div className={styles.groupBtns}>
                        {items.map((item, idx) => (
                            <button
                                disabled={item.disabled}
                                key={idx}
                                onClick={() => {
                                    item.onClick();
                                    setIsOpen(false);
                                }}
                            >
                                {item.label}
                            </button>
                        ))}
                    </div>
                </div>
            )}
        </div>
    );
};

export default RowMenu;